const SprinklerIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #fcfcfc; }
        .cls-2 { fill: #4d4d4d; }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 { fill: #fbfbfb; }
        .cls-6 { fill: #fafafa; }
        .cls-7 { fill: #fcfdfd; }
      `}</style>
    </defs>

    <g>
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path className="cls-7" d="M449.12,273.34c13.92-.08,27.03-.12,40.13-.28,11.67-.14,18.92,5.52,19.2,15.18.28,9.68-6.51,15.51-18.58,15.94-1.61.06-3.23,0-5.39,0 7.2,19.18 14.38,37.79 21.13,56.56 2,5.55 3.56,11.45 4.04,17.3.81,9.89-5.67,16.59-15.52,15.02-48.24-7.72-96.8-4.78-145.26-4.85-13.27-.02-26.62,1.46-39.8,3.27-16.24,2.23-24.7-6.83-19.76-22.51 3.49-11.07 7.34-22.03 11.23-32.96 3.89-10.93 8.03-21.78 12.3-33.33-2.58.13-4.92.23-7.25.37-10.4.63-16.71-4.48-17.25-13.98-.51-8.98 5.91-15.82 15.71-15.96 15.83-.24 31.67-.09 47.51-.05 32.24.07 64.48.18 97.53.29ZM330.93,339.27c-2.73,6.7-5.47,13.41-8.38,20.54h151.18c-6.95-18.64-13.72-37.11-20.88-55.42-.65-1.67-3.87-3.31-5.9-3.32-32.23-.23-64.46-.05-96.69-.36-4.96-.05-6.45,2.17-7.8,6.05-3.66,10.45-7.55,20.83-11.52,32.5Z" />
      <path className="cls-1" d="M293.28,201.14c90.14.4,179.45.75,268.77,1.39,4.51.03,9.73,1.61,13.31,4.25,4.49,3.3,7.19,9.24,3.41,14.4-2.87,3.9-7.54,7.79-12.07,8.84-6.49,1.51-13.58.47-20.41.46-98.11-.18-196.23-.36-294.34-.6-8.19-.02-16.4-.24-24.57-.8-7.89-.54-12.98-6.4-12.84-14.06.14-7.5,6.43-14.11,13.97-14.12,21.32-.03,42.63.14,64.77.24Z" />
      <path className="cls-5" d="M273.1,525.33c.32-5.02-.01-9.84 1.64-13.84 8.67-20.91 17.64-41.71 26.93-62.36 5.4-11.99 16.67-14.78 24.6-6 2.6,2.88 4.77,9.01 3.48,12.11-10.31,24.57-20.92,49.05-32.7,72.94-4.86,9.85-15.55,8.22-23.95-2.85Z" />
      <path className="cls-5" d="M500.72,465.52c6.92,15.91 13.75,31.19 19.93,46.73 2.84,7.14 3.33,14.27-5.15,18.99-8.41,4.68-16.69,3.09-20.35-5.82-9.33-22.7-18.22-45.6-26.74-68.62-3.18-8.59-.3-14.62 6.64-17.7 7.82-3.47 12.81,1.29 16.34,6.85 3.74,5.88 6.04,12.66 9.32,19.57Z" />
      <path className="cls-6" d="M394.45,442.13c13.36-.52 18.53,4.38 18.57,17.15.08,23.47.05,46.94.01,70.41-.01,8.37-6.85,15.49-14.56,15.33-7.25-.15-13.02-7.07-13.03-15.68 0-24.56.09-49.12-.06-73.67-.04-6.48,2.26-11,9.07-13.53Z" />
      <path className="cls-5" d="M443.3,608.69c-6.81-9.29-11.1-18.42-7.52-29.9 2.8-8.97 3.79-18.53 6.87-27.38 3.78-10.89 18.91-13.45 24.69-3.66 8.79,14.88 13.58,31.87 10.1,49.08-3.54,17.51-18.72,22.27-34.15,11.87Z" />
      <path className="cls-1" d="M317.58,571.27c1.9-6.34 3.54-12.05 5.32-17.72 2.06-6.53 6.55-11.8 13.27-11.06 5.27.59 13.01,3.7 14.65,7.73 6.44,15.75 11.57,32.32 6.05,49.67-2.6,8.16-11.36,14.27-19.04,14.31-8.62.05-14.17-4.88-18.77-14.17-4.65-9.38-5.72-18.47-1.48-28.77Z" />
    </g>
  </svg>
);

export default SprinklerIcon;